import type { ApiResponse, EmailTemplate } from '@klaro7/shared-types';
import type { UpdateEmailTemplateInput } from '@klaro7/validators';

import api from '@/lib/api';

export async function getEmailTemplates(): Promise<EmailTemplate[]> {
  const response = await api.get<ApiResponse<EmailTemplate[]>>('/settings/email-templates');
  return response.data.data;
}

export async function uploadEmailTemplateImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.post<ApiResponse<{ url: string }>>(
    '/settings/email-templates/upload',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data.data.url;
}

export async function updateEmailTemplate(
  slug: string,
  data: UpdateEmailTemplateInput,
): Promise<EmailTemplate> {
  const response = await api.put<ApiResponse<EmailTemplate>>(
    `/settings/email-templates/${slug}`,
    data,
  );
  return response.data.data;
}
